<template>
    <div class="flex flex-col items-stretch gap-6">
        <NuxtLink
            :to="`/texty/${item.kniha}/${item.kod}`"
            class="w-full"
        >
            <div class="group relative aspect-square bg-gray-500 p-2 md:p-7">
                <img
                    :src="`https://app.iprpraha.cz/apl/mnt/App_UAP/portal/images/texty_kapitoly/${item.kniha}_${item.kod}.webp`"
                    class="absolute inset-0 z-10"
                />
                <!-- <h2
                    class="heading-2 absolute inset-0 z-20 p-2 md:p-7 text-white drop-shadow-lg"
                >
                    {{ item.nazev }}
                </h2> -->
                <div
                    class="absolute inset-0 z-20 border border-transparent p-2 duration-150 group-hover:border-black-text group-hover:bg-transparent md:p-7"
                >
                    <h2
                        class="heading-2 absolute inset-0 z-20 p-2 text-white duration-150 group-hover:bg-white group-hover:text-black-text md:p-7"
                        v-html="correctTypography(item.nazev)"
                    />
                </div>
            </div>
        </NuxtLink>
        <div
            v-if="!store.mobileMode"
            class="flex w-full flex-col gap-1"
        >
            <NuxtLink
                v-for="child in children"
                :key="child.kod"
                :to="`/texty/${child.kniha}/${child.kod}`"
                class="flex w-full gap-2 font-proregular underline underline-offset-2 duration-150 hover:text-hover-link 2xl:text-lg"
            >
                <span class="w-fit">
                    {{ child.kod }}
                </span>
                <span
                    class=""
                    v-html="correctTypography(child.nazev)"
                />
            </NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
const store = useMainStore()
const { locale } = useI18n()
const localePath = useLocalePath()
const { item, children } = defineProps<{
    item: BookTreeItem
    children: BookTreeItem[] | undefined
}>()

watch(locale, () => {
    setTimeout(async () => {
        await navigateTo(localePath(`/texty`))
    }, 300)
})
</script>

<style scoped></style>
